import {
  FeedbackModel,
  UpdateFeedbackModel,
} from "../../apiModels/Feedback/FeedbackModel";
import { IHttpClient } from "../IHttpClient";
import { IFeedbackService } from "./IFeedbackService";

export class FeedbackService implements IFeedbackService {
  private readonly httpclient: IHttpClient;

  constructor(httpclient: IHttpClient) {
    this.httpclient = httpclient;
  }

  sendFeedback(feedbackModel: FeedbackModel): Promise<any> {
    return this.post(`v1/feedback`, feedbackModel);
  }

  askLater(model: UpdateFeedbackModel): Promise<any> {
    return this.post(`v1/feedback/ask-later`, model);
  }

  private post(url: string, body: any): Promise<any> {
    return this.httpclient.post(url, body);
  }
}
